/**
 * One Scan-window authority for the canonical Safety Scan report.
 * Stored Scan identity wins. Case / queue / reportOpen / last-complete-hour never replace it.
 */

export type CanonicalScanWindowSource = 'stored' | 'frozen' | 'unavailable';

export type CanonicalScanWindow = {
  start: string | null;
  end: string | null;
  source: CanonicalScanWindowSource;
};

function text(value?: string | null): string {
  return String(value || '').trim();
}

/**
 * Lock every report section to the displayed Scan's stored window.
 * Frozen verification.window is the already-frozen equivalent of those columns.
 * Forbidden inputs are accepted only so tests can prove they cannot win.
 */
export function resolveCanonicalScanWindow(input: {
  storedWindowStart?: string | null;
  storedWindowEnd?: string | null;
  frozenWindowStart?: string | null;
  frozenWindowEnd?: string | null;
  caseTimeWindow?: { start?: string | null; end?: string | null } | null;
  queueWindow?: { start?: string | null; end?: string | null } | null;
  reportOpenWindow?: { start?: string | null; end?: string | null } | null;
  lastCompleteHour?: { start?: string | null; end?: string | null } | null;
}): CanonicalScanWindow {
  void input.caseTimeWindow;
  void input.queueWindow;
  void input.reportOpenWindow;
  void input.lastCompleteHour;
  const storedStart = text(input.storedWindowStart);
  const storedEnd = text(input.storedWindowEnd);
  if (storedStart && storedEnd) {
    return { start: storedStart, end: storedEnd, source: 'stored' };
  }
  const frozenStart = text(input.frozenWindowStart);
  const frozenEnd = text(input.frozenWindowEnd);
  if (frozenStart && frozenEnd) {
    return { start: frozenStart, end: frozenEnd, source: 'frozen' };
  }
  return { start: null, end: null, source: 'unavailable' };
}

export function storedWindowFromPersistedReport(report?: {
  window_start_utc?: string | null;
  window_end_utc?: string | null;
  workflow_anchor?: {
    time_window?: { start?: string | null; end?: string | null; from?: string | null; to?: string | null } | null;
  } | null;
} | null): { start: string | null; end: string | null } {
  const start = text(report?.window_start_utc);
  const end = text(report?.window_end_utc);
  if (start && end) return { start, end };
  return { start: null, end: null };
}
